import MessagesService from 'js/services/api/citizen/messages'
import {mapGetters} from 'vuex'
import iconoCanalAtencion from 'assets/images/ico-soporte.svg'
import iconoSent from 'assets/images/ico-sent.svg'
import iconoCheck from 'assets/images/ico-check.svg'

import PhotoUploader from 'js/components/photo-upload'
import MessageCard from './_message-card'

import template from './index.pug'

// @vue/component
export default {
  name: 'citizen-messages-index',
  template: template(),
  components: {MessageCard, PhotoUploader},
  data() {
    return {
      messages: [],
      categories: [],
      message: {
        category: null,
        title: undefined,
        description: undefined,
        municipality_id: undefined,
        image: undefined,
        lat: undefined,
        lng: undefined
      },
      hasLocation: false,
      locationError: false,
      camera: undefined,
      errors: {},
      seeIncidence: false,
      id: '',
      title: '',
      category: '',
      response: '',
      description: '',
      status_chat: false,
      messageChat: [],
      messageSent: '',
      idIncidence: '',
      sentok: false,
      datosmodal: false,
      gpsActivo: false,
      gpsBuscando: false
    }
  },

  created() {
    this.loadCorrectCategory()
  },

  computed: {
    categoriesSelect() {
      const options = this.categories.map(cat => ({
        value: cat,
        label: this.$t(`citizenMessages.categories.options.${cat}`)
      }))

      return options
    },

    timeZone() {
      return this.currentMunicipality?.time_zone || null
    },
  },

  mounted() {
    this.$store.commit('setRedirectFromIncidents', false)
    if (this.$user == null) {
      this.datosmodal = true
    } else if (this.$user.name === '' || this.$user.name === null || this.$user.name === undefined) {
      this.datosmodal = true
    } else {
      this.searchMessage()
    }
    this.validarGPS()
     // --- Escuchar cambios de permisos de geolocalización ---
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
        permissionStatus.onchange = () => {
          // Si el usuario concede el permiso, vuelve a intentar obtener la ubicación
          if (permissionStatus.state === 'granted') {
            this.validarGPS()
          }
        }
      })
    }
  },

  methods: {
    /** Call service for load category use municipality_id */
    async loadCorrectCategory(){
      await MessagesService.listCategory({municipality_id: this.$store.state.municipality.municipality.id}).then(categories => {
        // Filtrar las categorías para eliminar 'unassigned'
        this.categories = categories.filter(category => category !== 'unassigned');
      })
    },

    async searchMessage(){
      await MessagesService.index({template: 'client_show'}).then(message => {
        this.messages = message.data
      })
    },

    goToCitizenMessagesNew() {
      if (this.canOpenIncident) {
        this.$router.push({name: 'citizen-messages-new'})
      } else {
        this.openPersonalDataModal()
      }
    },

    async showMessage(message) {
      this.status_chat = message.status_chat
      this.seeIncidence = true

      this.id = message.identifier
      this.title = message.title
      this.category = message.category
      this.description = message.description
      this.response = message.response
      const params = ''
      this.idIncidence = message.id

      await MessagesService.chatMessages(message.id).then(message => {
        this.messageChat = message
      })
    },

    closeModal() {
      this.seeIncidence = false
    },
    async save() {
      let lat
      let lng
      if (this.hasLocation == true) {
        lat = this.message.lat
        lng = this.message.lng
      }

      if (this.message.image !== undefined && this.message.image !== null) {
        const file = this.message.image
        if (file instanceof File) {
          this.fileToBase64(file).then(base64String => {
            this.message.image = base64String // Ahora tienes la cadena lista para enviar al backend
          }).catch(error => {
            console.error('Error al convertir a base64:', error)
          })
        }
      }

      const data = {
        category: this.message.category,
        title: this.message.title,
        description: this.message.description,
        municipality_id: this.$store.state.municipality.municipality.id,
        image: this.message.image,
        lat,
        lng
      }
      await MessagesService.create(data).then(message => {
      })
      this.sentok = true
      this.message.category = ''
      this.message.title = ''
      this.message.description = ''
      this.hasLocation = false

      this.searchMessage()
    },
    canalAtencion() {
      return iconoCanalAtencion
    },


    momentDate(fecha) {
      if (this.timeZone) {
        return moment(fecha).tz(this.timeZone)
      }

      return moment(fecha)
    },
    async sent() {
      // ns-icon-send

      const id = this.idIncidence
      const data = {
        content: this.messageSent
      }
      if (this.messageSent != '') {
        const params = ''

        await MessagesService.createChatMessage(id, {content: this.messageSent}).then(message => {
        })
        this.messageSent = ''
        await MessagesService.chatMessages(id).then(message => {
          this.messageChat = message
        })
      }
    },
    iconoSentChat() {
      return iconoSent
    },
    iconoCheckMessage() {
      return iconoCheck
    },
    closeModalsendok() {
      this.sentok = false
    },
    closeModalData() {
      if (this.$currentAppConfig.code === 'gc') {
        this.$router.push({name: 'home'})
        return
      }
      this.$router.push({name: 'municipality-nearests-stops'})
    },
    acceptModalData() {
      this.$store.commit('setRedirectFromIncidents', true)
      if (this.$currentAppConfig.code === 'gc') {
        this.$router.push({
          name: 'municipality-profile',
          params: {
            country: this.administrativeArea?.country_alpha2,
            municipality: this.administrativeArea?.name
          }
        })

        return
      }
      this.$router.push({name: 'municipality-profile'})
    },
    validarCampos() {
      if (this.message.category == '' || this.message.category == null || this.message.category == undefined) {
        return true
      }
      if (this.message.title == '' || this.message.title == null || this.message.title == undefined) {
        return true
      }

      if (this.message.description == '' || this.message.description == null || this.message.description == undefined) {
        return true
      }

      return false
    },

    validarGPS() {
      this.gpsBuscando = true;
      if ('geolocation' in navigator) {
        var vn = this;
        vn._geoWatchId = navigator.geolocation.watchPosition(
          position => {
            vn.gpsActivo = true;
            vn.gpsBuscando = false;
            vn.message.lng = position.coords.longitude;
            vn.message.lat = position.coords.latitude;
          },
          error => {
            vn.gpsActivo = false;
            vn.gpsBuscando = false;
          }
        );
      } else {
        this.gpsActivo = false;
        this.gpsBuscando = false;
      }
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result) // Incluye el prefijo data:image/...;base64,...
        }
        reader.onerror = error => {
          reject(error)
        }
        reader.readAsDataURL(file)
      })
    }

  }
}
